<template>
  <div class="my_order">
    <div class="order_main">
      <div class="order_left">
        <user-tab></user-tab>
      </div>

      <div class="order_right">
        <div class="setting">
          <div class="title-default">个人设置</div>
          <div class="setting-info">
            <div class="avatar">
              <a-upload
                name="avatar"
                listType="picture-card"
                class="avatar-uploader upload-avatar"
                :showUploadList="false"
                :action="baseApl + '/common/common/upload_file'"
                :beforeUpload="beforeUpload"
                @change="handleChange"
              >
                <img
                  v-if="imageUrl"
                  :src="!imageUrl ? defaultAvatar : imageUrl"
                  alt="avatar"
                />
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <img class="def-img" :src="defaultAvatar" alt="" />
                </div>
              </a-upload>
              <div class="avatar-text">修改头像</div>
            </div>
            <div class="avatar-list">
              <span>手机号码：</span>
              {{ $store.state.userPhone }}
            </div>
            <div class="avatar-list">
              <span>昵称：</span>
              <el-input
                class="default-input"
                v-model="name"
                placeholder="请输入您的昵称"
              ></el-input>
            </div>
            <div class="avatar-list">
              <span>性别：</span>
              <el-radio-group v-model="sex">
                <el-radio-button class="radio-button" label="1"
                  >男</el-radio-button
                >
                <el-radio-button class="radio-button" label="2"
                  >女</el-radio-button
                >
              </el-radio-group>
            </div>
            <div class="avatar-list">
              <span>邮箱：</span>
              <el-input
                class="default-input"
                v-model="email"
                placeholder="请输入邮箱"
              ></el-input>
            </div>
            <div class="avatar-list avatar-cascader">
              <span>地址：</span>
              <el-cascader
                class="default-input"
                v-model="cityCode"
                :options="cityOptions"
                :props="TypeProps"
              ></el-cascader>
            </div>
            <div class="avatar-list avatar-address">
              <span></span>
              <el-input
                class="default-input"
                v-model="address"
                placeholder="请输入详细地址"
              ></el-input>
            </div>
            <el-button class="avatar-submit" @click="isSubmit()"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userTab from "./../../components/user/user_tab";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  components: {
    userTab
  },
  data() {
    return {
      loading: false,
      imageUrl: "",
      defaultAvatar: require("@/assets/img/pic_head_nor.png"),
      input: "",
      name: "",
      sex: "0",
      cityCode: [],
      email: "",
      address: "",
      cityOptions: [],
      TypeProps: { expandTrigger: "hover", value: "code", label: "name" },
      baseApl: process.env.VUE_APP_BASE_API
    };
  },
  // 接收注入的数据
  inject: ["reload"],
  mounted() {
    var _this = this;
    // 用户信息
    this.$fetch(`/user/api/customer`).then(res => {
      if (res.code == 0) {
        let areaCode = [];
        _this.imageUrl = res.data.avatar;
        _this.email = res.data.email;
        _this.name = res.data.nickname;
        _this.address = res.data.address;
        _this.sex = res.data.gender;
        areaCode = res.data.areaCode.split("_");
        _this.cityCode[0] = areaCode[0];
        _this.cityCode[1] = areaCode[0] + "_" + areaCode[1];
        if (areaCode[2] != null) {
          _this.cityCode[2] =
            areaCode[0] + "_" + areaCode[1] + "_" + areaCode[2];
        }
      } else {
        // this.$message(res.message);
      }
    });

    for (let i of _this.$store.state.headerTabList) {
      i.isSelected = false;
      if (i.name == "首页") {
        i.isSelected = true;
      }
    }
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "个人设置") {
        i.isSelected = true;
      }
    }
    // 获取城市
    this.$fetch(`/common/api/area`).then(res => {
      if (res.code == 0) {
        _this.cityOptions = res.data;
      } else {
        this.$message(res.message);
      }
    });
  },

  methods: {
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("头像只能上传jpg、png格式");
      }
      //   const isLt2M = file.size / 1024 / 1024 < 2
      //   if (!isLt2M) {
      //     this.$message.error('Image must smaller than 2MB!')
      //   }
      return isJPG;
    },
    isSubmit() {
      this.$message.closeAll();
      let _this = this;
      let imageUrl = "";
      this.$post(`/common/common/uploadbase64img`, {
        folder: "article/",
        base64Img: this.imageUrl
      }).then(res => {
        imageUrl = res.message;
        this.$post(
          `/user/api/customer/modify?avatar=${imageUrl}&gender=${
            this.sex
          }&areaCode=${this.cityCode[this.cityCode.length - 1]}&address=${
            this.address
          }&email=${this.email}&nickname=${this.name}`
        ).then(res => {
          if (res.code == 0) {
            // 用户信息
            this.$fetch(`/user/api/customer`).then(res => {
              if (res.code == 0) {
                _this.$store.state.userName = res.data.nickname;
                _this.$store.state.userPhone = res.data.username;
                _this.$store.state.userAvatar = res.data.avatar;
                _this.$store.state.hasPwd = res.data.hasPwd;
                _this.$store.state.userInfo = res.data;
              } else {
                // this.$message(res.message);
              }
            });
            this.$message({
              message: res.message,
              type: "success"
            });
          } else {
            this.$message(res.message);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss">
.setting-info {
  .ant-upload.ant-upload-select-picture-card {
    margin: 0 auto;
    width: 75px;
    height: 75px;
    // background: url("../../assets/img/avatar.svg") no-repeat;
    background-size: cover;
    border: none;
    border-radius: 50%;
    .anticon-plus {
      display: none;
    }
  }
  .ant-upload.ant-upload-select-picture-card > .ant-upload {
    padding: 0;
  }
  .ant-upload.ant-upload-select-picture-card > .ant-upload > img {
    width: 75px;
    height: 75px;
    border-radius: 50%;
  }
  .avatar-list {
    .radio-button {
      span {
        width: 50px;
        height: 30px;
        border-radius: 2px;
        border: 1px solid rgba(190, 192, 198, 1);
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
      }
    }
    .el-radio-button__inner:hover {
      color: #3455d3;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      border: 1px solid rgba(52, 85, 211, 1);
      background: transparent;
      color: #3455d3;
      box-shadow: none;
    }
  }
  .default-input {
    line-height: 30px;
    input {
      width: 100%;
    }
    .el-input .el-input__suffix {
      width: auto;
    }
  }
}
</style>
<style lang="scss" scoped>
.setting {
  background: #ffffff;
  .setting-info {
    padding: 0 303px 32px 303px;
    .avatar-text {
      height: 12px;
      font-size: 12px;
      color: rgba(94, 96, 102, 1);
      line-height: 1;
      margin-top: 8px;
      text-align: center;
      margin-bottom: 40px;
    }
    .avatar-list {
      margin-top: 16px;
      font-size: 12px;
      line-height: 1;
      color: #2f3133;
      display: flex;
      align-items: center;
      span {
        color: #5e6066;
        display: inline-block;
        width: 60px;
        margin-right: 10px;
        text-align: right;
      }
      .default-input {
        width: 215px;
      }
    }
    .avatar-cascader {
      height: 30px;
    }
    .avatar-address {
      margin-top: 8px;
    }
    .avatar-submit {
      width: 108px;
      height: 30px;
      background: rgba(52, 85, 211, 1);
      border-color: rgba(52, 85, 211, 1);
      border-radius: 2px;
      margin-left: 70px;
      padding: 0;
      margin-top: 24px;
      color: #ffffff;
    }
  }
}
</style>
<style lang="scss" scoped>
.my_order {
  &/deep/.ant-upload-picture-card-wrapper {
    display: flex;
  }
}
</style>
